import { PropsWithChildren, ReactNode, useSyncExternalStore } from 'react';
interface Props {
  fallback?: ReactNode;
}
const emptySubscribe = () => () => {};
export function ClientGate(props) {
  const {
    children,
    fallback
  } = props;
  const isServer = useSyncExternalStore(emptySubscribe, _temp, _temp2);
  return isServer ? fallback : children;
}
function _temp2() {
  return true;
}
function _temp() {
  return false;
}